import { persistentStore } from '@store/persistentStore';

export function useScrollToTop(): () => void {
  const scrollToTopOnPageChange = persistentStore((s) => s.scrollToTopOnPageChange);
  const smoothScrollToTopOnPageChange = persistentStore((s) => s.smoothScrollToTopOnPageChange);

  function scrollToTop(): void {
    if (scrollToTopOnPageChange) {
      window.scrollTo({
        top: 0,
        behavior: smoothScrollToTopOnPageChange ? 'smooth' : 'auto',
      });
    }
  }

  return scrollToTop;
}
